import { Plugin } from '@tiptap/pm/state'

export const handleImageClickPlugin = () =>
  new Plugin({
    props: {
      handleClick(view, _, event) {
        // open in new tab
        const target = event.target as HTMLElement

        if (target.tagName === 'IMG') {
          const src = target.getAttribute('src')
          if (src) {
            window.open(src, '_blank')
          }
        }
      },
    },
  })
